<template>
  <div>
    <van-popup v-model="show" :overlay="false" position="top" :style="{ height: '100%', padding : '10px'}" :lock-scroll="true" :closeable="true" @close="close">
      <div style="height:40px;text-align:center;font-size:16px;line-height:36px;color:#EE7700">新增供应商</div>
      <van-form @submit="onSubmit">
        <van-field v-model="Name" name="Name" label="供应商名称" placeholder="请输入供应商名称" :rules="[{ required: true, message: '请填写供应商名称' }]" />
        <van-field v-model="Address" name="Address" label="供应商简称" placeholder="请输入供应商简称" />
        <van-field v-model="ShortName" name="ShortName" label="供应商地址" placeholder="请输入供应商地址" />
        <van-button round block type="info" native-type="submit" style="margin-top:80%;background-color:#EE7700;border:none;" >提交</van-button>
      </van-form>
    </van-popup>
  </div>
</template>

<script>
import { addSupplier } from "~/api/supplier";

export default {
  name: "AddView",
  components: {
  },
  data() {
    return {
      Name:"",
      Address:"",
      ShortName:""
    };
  },

  props: {
    show: Boolean,
  },

  methods: {
    async onSubmit(data){
      let loading = this.$toast.loading({
        message: "正在保存...",
        forbidClick: true,
        duration: 0,
      });
      try{
        const res = await addSupplier(data);
        loading.clear();
        this.$emit("supplierCb",{SupplierName:this.Name,SupplierId:res})
      }catch{
        loading.clear();
        Toast.fail("操作失败，请重试！");
      }
    },

    async close(){
      this.$emit("supplierCb",null)
    }
  },

  watch:{
    show:{
      handler(v){
        if(v){
          this.Name="";
          this.Address="";
          this.ShortName="";
        }
      }
    }
  }
};
</script>

<style lang="less" scope></style>
